import styled from 'styled-components'

import BaseButton from '~/views/components/ui/Button'
import BaseDialog from '~/views/components/ui/Dialog/BaseDialog'

export const DialogTitle = styled.div(
  ({ theme }) => `
  text-align: center;
  padding: ${theme.spacing(4)} 0;
`,
)

export const DialogBody = styled.div`
  text-align: center;
`

export const DialogActions = styled.div(
  ({ theme }) => `
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing(3)};
`,
)

export const Button = styled(BaseButton)(
  ({ theme }) => `
  &&& {
    text-transform: capitalize;
    min-width: ${theme.spacing(12)};
    width: auto;
    font-weight: bold;
    letter-spacing: 0.5px;
  }
`,
)

export const Dialog = styled(BaseDialog)(
  ({ theme }) => `
  & .MuiDialog-paper {
    max-height: 100vh;
    min-height: 200px;
    height: 265px;
    min-width: 600px;
    width: 650px;
    max-width: 650px;
  }
  & .MuiDialogTitle-root {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing(3)};
    padding-bottom: 0;
  }
  & .MuiDialogContent-root {
    padding: ${theme.spacing(3)};
    padding-top: 0;
    display: grid;
    grid-template-rows: auto 1fr ${theme.spacing(7)};
    height: 100%;
  }
`,
)
